export default __webpack_public_path__ + "static/media/Barricades2 (1).19eff11b.jpg";